"use client";
import React, { createContext, useContext, useMemo, useState } from "react";

export type AuthUser = {
  id?: string;
  email?: string;
  name?: string;
} | null;

type AuthContextValue = {
  user: AuthUser;
  setUser: (u: AuthUser) => void;
};

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within <AuthProvider>");
  return ctx;
}

export default function AuthProvider({
  children,
  initialUser,
}: {
  children: React.ReactNode;
  initialUser: AuthUser;
}) {
  const [user, setUser] = useState<AuthUser>(initialUser ?? null);
  const value = useMemo(() => ({ user, setUser }), [user]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}


